import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "acadmy--sprite",
  "use": "acadmy--sprite-usage",
  "viewBox": "0 0 19 15",
  "content": "<symbol viewBox=\"0 0 19 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"acadmy--sprite\">\n<path d=\"M3.33333 8.48333V11.8167L9.16667 15L15 11.8167V8.48333L9.16667 11.6667L3.33333 8.48333ZM9.16667 0L0 5L9.16667 10L16.6667 5.90833V11.6667H18.3333V5L9.16667 0Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol